import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Layout, PageHeader, Button, Icon, Input, Select } from 'antd'
import { observer, inject } from 'mobx-react'

import { companies, policies } from '@services/api'

import List from './List'
import AddPolicyPopup from '@components/Popup/AddPolicyPopup'

@inject((store: any) => {
    const { popupStore } = store
    return { popupStore }
})
@observer
class PoliciesList extends Component<any, any> {
    state = {
        company: {},
        policies: [],
        filtered: [],
        categories: {},
        textFilter: '',
        categoryFilter: null,
        loading: true
    }

    componentDidMount() {
        const { id } = this.props.computedMatch.params
        this.getCompany(id)
        this.getPolicies(id)
    }

    getCompany = async id => {
        const company: any = await companies.getCompany({ id })
        this.setState(prevState => ({ ...prevState, loading: false, company: company.data }))
    }

    getPolicies = async id => {
        const { data } = await policies.getList({ company_id: id })
        this.setState(prevState => ({
            ...prevState,
            loading: false,
            categories: data.categories,
            policies: data.policies
        }))
        this.filterPolicies()
    }

    handleAddPolicy = () => {
        // this.props.popupStore.togglePopup('addCompany', {})
    }

    filterPolicies = () => {
        const { policies, textFilter, categoryFilter } = this.state

        const filtered = policies.filter(policy => {
            if (!categoryFilter) {
                return policy.name.includes(textFilter) || policy.id.toString().includes(textFilter)
            } else {
                return (
                    (policy.name.includes(textFilter) || policy.id.toString().includes(textFilter)) &&
                    policy.category_id === parseInt(categoryFilter)
                )
            }
        })

        this.setState(prevState => ({ ...prevState, filtered }))
    }

    setFilter = async filter => {
        await this.setState(prevState => ({ ...prevState, ...filter }))
        this.filterPolicies()
    }

    render() {
        const { company, filtered, loading, categories, policies } = this.state

        const categoriesList = []
        let { Option } = Select

        if (!loading) {
            for (let key in categories) {
                if (key && key != null) {
                    categoriesList.push(
                        <Option key={key} value={key}>
                            {categories[key]}
                        </Option>
                    )
                }
            }
        }

        const header = !loading ? (
            <PageHeader
                onBack={() => window.history.back()}
                title={`פוליסות ${company['name']}`}
                subTitle={
                    filtered < policies
                        ? `מציג ${filtered.length} פוליסות מתוך ${policies.length}`
                        : `סה"כ ${policies.length} פוליסות`
                }
            >
                <Button
                    style={{ fontSize: '1rem' }}
                    onClick={() =>
                        this.props.popupStore.togglePopup('addPolicy', {
                            company_id: company['id'],
                            company: company['name']
                        })
                    }
                >
                    <Icon type="plus" /> הוספת פוליסה
                </Button>
                <Input.Search
                    placeholder="חיפוש על פי שם פוליסה או מזהה"
                    onChange={e => this.setFilter({ textFilter: e.target.value })}
                    style={{ width: '50%', marginRight: '0.5rem' }}
                />
                <Select
                    placeholder="סינון על פי קטגוריה"
                    style={{ width: '20%', marginRight: '1rem' }}
                    onChange={e => this.setFilter({ categoryFilter: e })}
                >
                    <Option key="no_value" value={null}>
                        ללא סינון
                    </Option>
                    {categoriesList}
                </Select>
            </PageHeader>
        ) : (
            <PageHeader onBack={() => window.history.back()} title={`בטעינה`}>
                טוען פוליסות
            </PageHeader>
        )
        return (
            <Layout>
                {header}
                <List list={filtered} loading={loading} company={this.props.computedMatch.params.id} />
                <AddPolicyPopup />
            </Layout>
        )
    }
}

export default withRouter(PoliciesList)
